import { APICONFIG } from '@config/api.config';
import { IQueryResponse } from '@services/api';
import { APIService } from '@services/api/common-services';
import { useQuery } from '@tanstack/react-query';

export interface ISiteVisitActiveUrl {
	display_value: string;
	mandatory: boolean;
	url: string;
}

interface ISiteVisitActiveUrlResponse {
	data: ISiteVisitActiveUrl[];
	count: number;
	next: string | null;
	previous: string | null;
	message: string;
}

export const useSiteVisitActiveUrlQuery = (): IQueryResponse<ISiteVisitActiveUrlResponse> => {
	const fetchActiveUrls = async (): Promise<ISiteVisitActiveUrlResponse> => {
		return await APIService.getData<ISiteVisitActiveUrlResponse>(APICONFIG.SITE_VISIT_ACTIVE_URL);
	};

	const { data, error, isLoading, isPending, isFetching, refetch } = useQuery({
		queryKey: ['siteVisitActiveUrl'],
		queryFn: fetchActiveUrls,
		refetchOnWindowFocus: false,
		retry: false,
	});

	return {
		data,
		error,
		isLoading,
		isPending,
		isFetching,
		refetch,
	};
};
